import { render, staticRenderFns } from "./paymentDetailModel.vue?vue&type=template&id=3b22e8f4&scoped=true&"
import script from "./paymentDetailModel.vue?vue&type=script&lang=js&"
export * from "./paymentDetailModel.vue?vue&type=script&lang=js&"
import style0 from "./paymentDetailModel.vue?vue&type=style&index=0&id=3b22e8f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b22e8f4",
  null
  
)

export default component.exports